// <s-card-gallery>: per-card image swipe on touch layouts. Marks the dot for the
// slide in view. Desktop hover-swap is pure CSS; without JS the track still swipes.
class SCardGallery extends HTMLElement {
  #track;
  #dots = [];
  #frame = 0;

  connectedCallback() {
    this.#track = this.querySelector('[data-card-track]');
    this.#dots = [...this.querySelectorAll('[data-card-dot]')];
    if (!this.#track || this.#dots.length < 2) return;
    this.#track.addEventListener('scroll', this.#onScroll, { passive: true });
  }

  disconnectedCallback() {
    this.#track?.removeEventListener('scroll', this.#onScroll);
    cancelAnimationFrame(this.#frame);
  }

  #onScroll = () => {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(() => {
      const width = this.#track.clientWidth || 1;
      const index = Math.round(Math.abs(this.#track.scrollLeft) / width);
      this.#dots.forEach((dot, i) => dot.toggleAttribute('data-active', i === index));
    });
  };
}

if (!customElements.get('s-card-gallery')) customElements.define('s-card-gallery', SCardGallery);
